// src/components/course/ReviewContent.js
import React from "react";

function ReviewContent({ value, onChange, readOnly }) {
  if (readOnly) {
    return (
      <p className="text-sm text-gray-800 whitespace-pre-line leading-relaxed">
        {value}
      </p>
    );
  }

  return (
    <textarea
      value={value}
      onChange={(e) => onChange && onChange(e.target.value)}
      rows={6}
      className="w-full rounded-2xl bg-gray-100 shadow-inner border-none px-4 py-4 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-[rgb(0,224,198)] resize-none placeholder-gray-400"
      placeholder="다른 러너들에게 도움이 될 수 있는 꿀팁이나 후기를 자세히 적어주세요!"
    />
  );
}

export default ReviewContent;
